var _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPolyscanLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 238,
    height: 238,
    viewBox: "0 0 238 238",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 119.279,
    cy: 119.269,
    r: 98.3493,
    fill: "#F9F9F9"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M152.855 97.5651C150.535 96.2397 147.553 96.2397 144.902 97.5651L126.346 108.5L113.755 115.458L95.5302 126.393C93.2107 127.718 90.2285 127.718 87.5777 126.393L73.3295 117.778C71.01 116.452 69.3532 113.801 69.3532 110.819V94.2515C69.3532 91.6007 70.6786 88.9499 73.3295 87.2931L87.5777 79.0092C89.8972 77.6838 92.8794 77.6838 95.5302 79.0092L109.778 87.6244C112.098 88.9499 113.755 91.6007 113.755 94.5829V105.518L126.346 98.2278V86.9617C126.346 84.3109 125.021 81.6601 122.37 80.0033L95.8616 64.4296C93.5421 63.1042 90.5599 63.1042 87.9091 64.4296L60.738 80.3346C58.0871 81.6601 56.7617 84.3109 56.7617 86.9617V118.109C56.7617 120.76 58.0871 123.411 60.738 125.068L87.5777 140.641C89.8972 141.967 92.8794 141.967 95.5302 140.641L113.755 130.038L126.346 122.748L144.571 112.145C146.89 110.819 149.872 110.819 152.523 112.145L166.771 120.429C169.091 121.754 170.748 124.405 170.748 127.387V143.955C170.748 146.606 169.422 149.256 166.771 150.913L152.855 159.197C150.535 160.522 147.553 160.522 144.902 159.197L130.654 150.913C128.334 149.588 126.678 146.937 126.678 143.955V133.351L114.086 140.641V151.576C114.086 154.227 115.411 156.878 118.062 158.534L144.902 174.108C147.222 175.433 150.204 175.433 152.855 174.108L179.694 158.534C182.014 157.209 183.671 154.558 183.671 151.576V120.097C183.671 117.446 182.345 114.796 179.694 113.139L152.855 97.5651Z",
    fill: "#8247E5"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 0.929688,
    y: 0.919922,
    width: 236.699,
    height: 236.699,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.137255 0 0 0 0 0.121569 0 0 0 0 0.12549 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolyscanLogo);
export default __webpack_public_path__ + "static/media/polyscan-logo.5045a3af6a5164962fc5798d3d983fde.svg";
export { ForwardRef as ReactComponent };